export default __webpack_public_path__ + "static/media/Stalker's Leggings of the Silent Kill.64df5c6a.jpg";